import { gql } from '@apollo/client';

export const FILTERED_TESTS = gql`
  query FilteredTests($input: SearchData!) {
    tests: filteredTestPerformances(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          averageMark
          emisNumber
          level1
          level2
          level3
          level4
          level5
          level6
          level7
          numberAbsent
          numberEnrolled
          numberWrote
          passRate
          possibleAttendance
          term
          year
          circuit {
            id
            name
          }
          promotionStatus {
            id
            name
          }
          district {
            id
            name
          }
          grade {
            id
            name
            value
          }
          subject {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
